import axios from "axios";
import { API_ROOT } from "./Api-config";

const Instense = axios.create();
 

//if (window.location.href.indexOf("login") <= 0) {
Instense.defaults.baseURL = `${API_ROOT.backendHost}`;

const getPunchAuth = () => {
  const token = localStorage.getItem("token")
    || localStorage.getItem("punchToken");

  const storageRaw = localStorage.getItem("storage")
    || localStorage.getItem("punchStorage");

  return { token, storageRaw };
};

const forceRedirectToLogin = () => {
  try {
    if (window.location.pathname.startsWith("/punch")) {
      localStorage.removeItem("punchToken");
      localStorage.removeItem("punchStorage");
    } else {
      localStorage.clear();
      sessionStorage.clear();
    }
  } catch (err) {
    // ignore localStorage clearing issues
  }

  if (window.location.pathname.startsWith("/punch")) {
    window.location.href = "/punch-login";
  } else if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

Instense.interceptors.request.use((config) => {
  const { token, storageRaw } = getPunchAuth();

  if (token && storageRaw) {
    config.headers.Authorization = `bearer ${token}`;
    const storage = JSON.parse(storageRaw!);
    const userName = storage === null ? "" : (storage.userName as any);
    const tenantID = storage === null ? "" : (storage.tenantID as any);
    config.headers.Username = userName;
    config.headers.tenantId = tenantID;
  }
  return config;
}, (err) => {
  console.log(err);
  return Promise.reject(err);
});
 

Instense.interceptors.response.use((response) => {
  
  return response;
}, (error) => {
 
  if (error?.response?.data?.message === "under maintenance") {
    window.location.href = "/Under-Maintenance";
  }
  else if (error.response && error?.response?.data && error?.response?.data?.error &&
    (error.response.data.session === false || error.response.data.session === "false") || (!getPunchAuth().token)) {
    if (error.response.data?.error?.message) {
      alert(error.response.data.error.message);
    }
    forceRedirectToLogin();
  }
  else if (error?.response && error?.response?.data && error?.response?.data?.error && error?.response?.data?.error?.message) {
    alert(error.response.data.error.message);
  }
  else
    if ((error?.response && error?.response?.status === 401) || (!getPunchAuth().token)) {
      if (error.response?.data?.error?.message) {
        alert(error.response.data.error.message);
      }
      forceRedirectToLogin();
    } else
      return Promise.reject(error);
});


export default Instense;
//export const AxiosRoot = `${Instense}`;

